module.exports = require('./readable').Transform



//////////////////
// WEBPACK FOOTER
// C:/Users/Craig/Documents/masteryprep/node_modules/readable-stream/transform.js
// module id = 1224
// module chunks = 0